import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import HistoryIcon from '@mui/icons-material/History';
import { useTranslation } from 'react-i18next';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import ReleaseNoteContent from '../release-note-content/release-note-content.component';
import { useReleaseNotePopup } from 'hooks/useReleaseNotePopup';

const ReleaseNotePopup: FC = () => {
    const { t: translate } = useTranslation('release-notes');
    const { isOpen, releaseNote, content, handleClose, handleViewAllReleaseNotes } = useReleaseNotePopup();

    if (!releaseNote) return null;

    const dialogTitle = (
        <Box display="flex" alignItems="center" gap={1}>
            <AutoAwesomeIcon color="primary" fontSize="small" />
            <Typography variant="h6" fontWeight={700}>
                {translate('WHATS_NEW', { version: releaseNote.version })}
            </Typography>
        </Box>
    );

    const dialogActions = (
        <Button startIcon={<HistoryIcon />} onClick={handleViewAllReleaseNotes} variant="text" size="small">
            {translate('VIEW_ALL_RELEASE_NOTES')}
        </Button>
    );

    return (
        <DHDialog
            open={isOpen}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            title={dialogTitle}
            actions={dialogActions}
        >
            <ReleaseNoteContent content={content} minHeight={50} />
        </DHDialog>
    );
};

export default ReleaseNotePopup;
